module.exports = __webpack_public_path__ + "static/media/work_3.a290fd7c.jpg";